<template>
  <v-container class="pa-0 ma-0 black" fluid>
    <v-navigation-drawer light app right v-model="info" width="375px">
      <template v-slot:prepend>
        <div class="pa-4 d-flex align-center">
          <v-btn icon @click="hide">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <span class="title pl-6 font-weight-light black--text"
            >Series information</span
          >
        </div>
      </template>

      <v-divider></v-divider>
      <v-list v-if="series">
        <v-list-item>
          <span class="font-weight-medium pr-4" style="min-width:60px"
            >Artist:</span
          >
          <span class="font-weight-light">{{
            series.artist ? series.artist.title : null
          }}</span>
        </v-list-item>
        <v-list-item v-if="series.description">
          <div class="pt-4">
            <v-divider></v-divider>
            <div
              class="pt-4 font-weight-light"
              v-html="series.description"
            ></div>
          </div>
        </v-list-item>
        <v-list-item v-if="series.song">
          <div class="pt-4">
            <div class="font-weight-medium mb-2">Song</div>
            <span class="font-weight-light">
              <a
                class="grey--text"
                style="text-decoration: none"
                :href="series.song.url"
                target="_blank"
                >{{ series.song.name
                }}<v-icon
                  color="grey"
                  class="ml-2"
                  style="vertical-align: baseline"
                  >mdi-open-in-new</v-icon
                ></a
              >
            </span>
          </div>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-fab-transition>
      <v-btn color="pink darken-1" dark fixed bottom right fab to="/">
        <v-icon color="white">mdi-home</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-row no-gutters class="ma-0 pa-0" align="start" v-if="series">
      <v-col
        class="d-flex child-flex blue"
        cols="12"
        xl="3"
        lg="3"
        md="3"
        sm="4"
        xs="12"
      >
        <v-img
          min-width="200px"
          :alt="`MetaPolis - ${series.artist.title}`"
          :title="`MetaPolis - ${series.artist.title}`"
          src="https://stayingathome.metapolis.gr/images/logoPlaceholderAlter.jpg"
          aspect-ratio="1"
          class="black"
        >
          <template>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <div class="d-flex flex-column align-center">
                <span
                  class=" mb-4 font-weight-medium white--text text-center title"
                  >{{ series.artist.title }}<br />
                  <span
                    class="pt-6 font-weight-light subtitle-1"
                    @click="show"
                    style="cursor: pointer"
                    >{{ series.name }}</span
                  ><br />
                  <v-btn v-if="series.description" dark icon @click="show">
                    <v-icon>mdi-information-outline</v-icon>
                  </v-btn>
                </span>
              </div>
            </v-row>
          </template>
        </v-img>
      </v-col>
      <v-col
        v-for="photo in series.photos"
        :key="photo.id"
        class="d-flex child-flex"
        cols="12"
        xl="3"
        lg="3"
        md="3"
        sm="4"
        xs="12"
      >
        <v-hover v-slot:default="{ hover }" :disabled="!clickable(photo)">
          <router-link
            class="pa-0 ma-0"
            :to="`/artists/${$route.params.slug}/images/${photo.id}`"
            v-if="clickable(photo)"
          >
            <v-img
              min-width="200px"
              :src="photo.thumb"
              aspect-ratio="1"
              :class="`${getRandomColor()} ma-0`"
            >
              <v-expand-transition>
                <div
                  v-if="hover"
                  class="d-flex flex-column align-center justify-center transition-fast-in-fast-out black darken-2 v-card--reveal white--text"
                  style="height: 100%; opacity: .9"
                >
                  <v-icon color="white" :size="48">mdi-fullscreen</v-icon>
                </div>
              </v-expand-transition>
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    width="2"
                    color="blue lighten-4"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </router-link>
          <v-img
            v-else
            min-width="200px"
            :src="photo.thumb"
            aspect-ratio="1"
            :class="`${getRandomColor()} ma-0`"
          >
            <v-expand-transition>
              <div
                v-if="hover"
                class="d-flex flex-column align-center justify-center transition-fast-in-fast-out black darken-2 v-card--reveal white--text"
                style="height: 100%; opacity: .9"
              >
                <span class="font-weight-light">{{ series.artist }}</span>
                <span class="mt-2">{{ photo.title }}</span>
              </div>
            </v-expand-transition>
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  width="2"
                  color="blue lighten-4"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-hover>
      </v-col>
    </v-row>
    <RouterView />
  </v-container>
</template>
<script>
import colors from "vuetify/lib/util/colors";
export default {
  name: "Gallery",
  data: () => ({
    series: null,
    info: false,
    logo: "https://stayingathome.metapolis.gr/images/metapolis.png"
  }),
  metaInfo() {
    return {
      meta: [
        {
          name: "title",
          content: `Metapolis | ${this.seriesName} | ${this.artistName}`
        },
        // Twitter Card
        { name: "twitter:card", content: "Metapolis | Staying at home" },
        {
          name: "twitter:title",
          content: `${this.seriesName} | ${this.artistName}`
        },
        {
          name: "twitter:description",
          content: "…η Μετάπολις είμαστε εμείς"
        },
        // image must be an absolute path
        { name: "twitter:image", content: this.logo },
        // Facebook OpenGraph
        {
          property: "og:title",
          content: `${this.seriesName} | ${this.artistName}`
        },
        { property: "og:site_name", content: "Metapolis | Staying at home" },
        { property: "og:type", content: "website" },
        { property: "og:image", content: this.logo },
        {
          property: "og:description",
          content: "…η Μετάπολις είμαστε εμείς"
        }
      ]
    };
  },
  computed: {
    artistName() {
      return _.get(this.series, "artist.title");
    },
    seriesName() {
      return _.get(this.series, "name");
    }
  },
  mounted() {
    this.series = this.$store.getters.getSeriesByArtistSlug(
      this.$route.params.slug
    );
  },
  methods: {
    clickable(photo) {
      return !_.has(photo, "clickable");
    },
    getRandomColor() {
      const keys = Object.keys(colors);
      return keys[Math.floor(Math.random() * keys.length)];
    },
    hide() {
      this.info = false;
    },
    show() {
      this.info = true;
    }
  }
};
</script>
<style>
a {
  color: transparent !important;
}
</style>
